export default "__VITE_ASSET__DEMUcvsH__"